import React, { Component } from 'react';
import './index.scss';

import Button from 'material-ui/Button';
import Grid from 'material-ui/Grid';
import {landingButton} from "../../constants/theme";

import {observer,inject} from 'mobx-react';

@inject("projectDataStore")
@observer
class Landing extends Component {

    constructor(props){
        super(props);
        this.state = {}

    }

    nextStep() {
        this.props.projectDataStore.setType('project');
        this.props.history.push('/wizard');
    }

    render() {
        return (
            <div className='landing'>
                <div className='layer1'>
                    <div className='senaWelcome'>
                        <span>ยินดีต้อนรับเข้าสู่</span>
                        <img src='assets/logo.png' alt='logoSena' className='logoSena'/>
                    </div>
                </div>
                <div className='layer2'>
                    <Grid container spacing={0}>
                        <Grid item xs={1} sm={3} md={4}></Grid>
                        <Grid item xs={10} sm={6} md={4}>
                            <span className=''>"คุณสามารถจำลองการติดตั้งระบบโซลาร์เซลล์ในบ้านของคุณได้แล้ววันนี้"</span>
                            <br/><br/>
                            <Button raised
                                    style={landingButton}
                                    onClick={() => this.nextStep()}
                            >เริ่มจำลองการติดตั้ง</Button>
                        </Grid>
                    </Grid>
                </div>
                <div className='layer3'></div>
            </div>
        );
    }
}

export default Landing;


// WEBPACK FOOTER //
// ./src/components/landing/index.js